import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const ViewsBadgeWrapper = styled(Flex)
    .withConfig({ displayName: 'ViewsBadgeWrapper' })
    .attrs((props) => ({
        ...props,
        borderRadius: 1,
        px: 0.5,
        py: 0.5,
        spacing: 0.5,
        justifyContent: 'center',
        direction: 'row',
        alignItems: 'center',
        background: props.background || 'var(--badge-black-blur)',
        width: 'fit-content',
    }))``;
